import { Getter } from "vuex";
import { IState } from './state';

const menuItems: Getter<IState, IState> = (state) => state.menuItems
const rootPage: Getter<IState, IState> = (state) => state.rootPage
export default {
	menuItems,
	rootPage
}
